export const NO_PERMISSION_TYPE = {
  ROOM_VERIFY: 'ROOM_VERIFY', // 需要验证
  FRIEND_ROOM_NO_PERMISSION: 'FRIEND_ROOM_NO_PERMISSION', // 无权限加入好友房间
  ROOM_NO_ROLE: 'ROOM_NO_ROLE', // 权限不足
};

export const NO_PERMISSION_TEXT = {
  [NO_PERMISSION_TYPE.ROOM_VERIFY]: '当前房间已开启房间验证,请通过邀请链接加入房间',
  [NO_PERMISSION_TYPE.FRIEND_ROOM_NO_PERMISSION]: '没有权限进入好友语音房间',
  [NO_PERMISSION_TYPE.ROOM_NO_ROLE]: '权限不足',
};
